module.exports = __webpack_public_path__ + "static/media/PerfRecup.3b2d8a1a.jpg";